import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiClock, FiX } = FiIcons;

const socialProofMessages = [
  {
    message: "Someone from Andheri just enquired for Elderly Care",
    area: "Andheri",
    service: "Elderly Care",
    time: "Just now"
  },
  {
    message: "2 minutes ago: Baby Care service booked in Bandra",
    area: "Bandra",
    service: "Baby Care",
    time: "2 min ago"
  },
  {
    message: "Patient Care enquiry received from Powai",
    area: "Powai",
    service: "Patient Care",
    time: "5 min ago"
  },
  {
    message: "Live-in caretaker assigned in Juhu",
    area: "Juhu",
    service: "Elderly Care",
    time: "10 min ago"
  },
  {
    message: "Japa Maid service confirmed in Goregaon",
    area: "Goregaon",
    service: "Japa Maid",
    time: "15 min ago"
  },
  {
    message: "Nursing services enquiry from Kandivali",
    area: "Kandivali",
    service: "Nursing Services",
    time: "20 min ago"
  }
];

const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(0);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Show popup after 3 seconds
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    // Rotate messages every 8 seconds
    const messageTimer = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % socialProofMessages.length);
    }, 8000);

    return () => {
      clearTimeout(showTimer);
      clearInterval(messageTimer);
    };
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ 
            opacity: isClosing ? 0 : 1, 
            y: isClosing ? 50 : 0, 
            scale: isClosing ? 0.9 : 1 
          }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="fixed bottom-4 right-4 z-50 max-w-sm"
        >
          <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 relative">
            {/* Close button */}
            <button
              onClick={handleClose}
              className="absolute -top-2 -right-2 bg-gray-100 hover:bg-gray-200 rounded-full p-1 transition-colors"
            >
              <SafeIcon icon={FiX} className="w-3 h-3 text-gray-600" />
            </button>
            
            {/* Message content */}
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiMapPin} className="w-4 h-4 text-green-600" />
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-800 font-medium leading-tight">
                  {socialProofMessages[currentMessage].message}
                </p>
                <div className="flex items-center space-x-2 mt-1">
                  <SafeIcon icon={FiClock} className="w-3 h-3 text-gray-400" />
                  <span className="text-xs text-gray-500">
                    {socialProofMessages[currentMessage].time}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SocialProofPopup;